// Author: Sunil Jain
// Timestamp: 2025-04-23T12:54:15EDT
// File: src/utils/logger.js
// Description: Basic console logger utility for frontend.

const logger = {
    info: (...args) => {
        console.info('[INFO]', ...args);
    },
    debug: (...args) => {
        // Only log debug messages in development environments
        if (process.env.NODE_ENV === 'development') {
            console.debug('[DEBUG]', ...args);
        }
    },
    warn: (...args) => {
        console.warn('[WARN]', ...args);
    },
    error: (...args) => {
        console.error('[ERROR]', ...args);
    },
};

export default logger;